import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ChoiceGrid, StepFooter, StepHeader, UnitToggle } from "./_widgets";

const GENDERS = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "prefer_not_to_say", label: "Prefer not to say" },
];

export default function Step1AboutYou({ data, set, onNext }) {
  const heightUnit = data.height_unit || "imperial";
  const weightUnit = data.weight_unit || "lbs";

  const ageOk = data.age && Number(data.age) >= 13 && Number(data.age) <= 100;
  const heightOk =
    heightUnit === "imperial"
      ? data.height_feet !== "" && data.height_inches !== ""
      : data.height_cm !== "";
  const weightOk = data.current_weight && Number(data.current_weight) > 0;
  const genderOk = !!data.gender;
  const valid = ageOk && heightOk && weightOk && genderOk;

  return (
    <div className="space-y-5">
      <StepHeader title="About You" subtitle="The basics so we can calibrate everything else." />

      <div className="space-y-1.5">
        <Label>Age</Label>
        <Input
          type="number"
          inputMode="numeric"
          min={13}
          max={100}
          placeholder="e.g. 28"
          value={data.age}
          data-testid="onb-age"
          onChange={(e) => set({ age: e.target.value })}
        />
      </div>

      <div className="space-y-1.5">
        <div className="flex items-center justify-between">
          <Label>Height</Label>
          <UnitToggle
            value={heightUnit}
            onChange={(v) => set({ height_unit: v })}
            left={{ value: "imperial", label: "ft/in" }}
            right={{ value: "metric", label: "cm" }}
            testid="onb-height-unit"
          />
        </div>
        {heightUnit === "imperial" ? (
          <div className="grid grid-cols-2 gap-2">
            <Input
              type="number"
              min={3}
              max={8}
              placeholder="ft"
              value={data.height_feet}
              data-testid="onb-height-ft"
              onChange={(e) => set({ height_feet: e.target.value })}
            />
            <Input
              type="number"
              min={0}
              max={11}
              placeholder="in"
              value={data.height_inches}
              data-testid="onb-height-in"
              onChange={(e) => set({ height_inches: e.target.value })}
            />
          </div>
        ) : (
          <Input
            type="number"
            min={100}
            max={250}
            placeholder="e.g. 178"
            value={data.height_cm}
            data-testid="onb-height-cm"
            onChange={(e) => set({ height_cm: e.target.value })}
          />
        )}
      </div>

      <div className="space-y-1.5">
        <div className="flex items-center justify-between">
          <Label>Current weight</Label>
          <UnitToggle
            value={weightUnit}
            onChange={(v) => set({ weight_unit: v })}
            left={{ value: "lbs", label: "lbs" }}
            right={{ value: "kg", label: "kg" }}
            testid="onb-weight-unit"
          />
        </div>
        <Input
          type="number"
          min={50}
          max={700}
          placeholder={weightUnit === "lbs" ? "e.g. 185" : "e.g. 84"}
          value={data.current_weight}
          data-testid="onb-weight"
          onChange={(e) => set({ current_weight: e.target.value })}
        />
      </div>

      <div className="space-y-1.5">
        <Label>Gender</Label>
        <ChoiceGrid
          options={GENDERS}
          value={data.gender}
          onChange={(v) => set({ gender: v })}
          testid="onb-gender"
        />
      </div>

      <StepFooter valid={valid} onNext={onNext} />
    </div>
  );
}
